// Add this file to your src directory and import it in your index.js or App.js

// This script adds RTL Bootstrap CSS to the document if it's not already included
function addBootstrapRTL() {
  // Check if RTL Bootstrap is already included
  const existingLink = document.querySelector('link[href*="bootstrap.rtl"]');
  if (!existingLink) {
    // Create link element for Bootstrap RTL CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.rtl.min.css';
    link.integrity = 'sha384-DOXMLfHhQkvFFp+rWTZwVlPVqdIhpDVYT9csOnHSgWQWPX0v5MCGtjCJbY6ERspU';
    link.crossOrigin = 'anonymous';
    
    // Add to document head
    document.head.appendChild(link);
  }
  
  // Set document direction
  document.documentElement.setAttribute('dir', 'rtl');
  document.documentElement.setAttribute('lang', 'ar');
}

// Add RTL support classes to fix common Bootstrap RTL issues
function addRTLSupportClasses() {
  const style = document.createElement('style');
  style.innerHTML = `
    /* Fix for RTL icons */
    .dropdown-toggle::after {
      margin-right: 0.255em;
      margin-left: 0;
    }
    
    /* RTL margins */
    .ms-1, .ms-2, .ms-3, .ms-4, .ms-5 {
      margin-right: var(--bs-spacer) !important;
      margin-left: 0 !important;
    }
    
    .me-1, .me-2, .me-3, .me-4, .me-5 {
      margin-left: var(--bs-spacer) !important;
      margin-right: 0 !important;
    }
    
    /* Set RTL for modal dialogs */
    .modal-header .btn-close {
      margin: -0.5rem auto -0.5rem -0.5rem;
    }
  `;
  
  document.head.appendChild(style);
}

// Run the functions
addBootstrapRTL();
addRTLSupportClasses();

// Export as named exports to avoid the eslint warning
export { addBootstrapRTL, addRTLSupportClasses };
